import React from "react";
import Container from "../../Component/MDBShim/Container";
import Spinner from "../../Component/MDBShim/Spinner";

import MUICard from "@mui/material/Card";
import MUICardContent from "@mui/material/CardContent";
import MUIFormControl from "@mui/material/FormControl";
import MUIInputLabel from "@mui/material/InputLabel";
import MUISelect from "@mui/material/Select";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIBox from "@mui/material/Box";
import MUITypography from "@mui/material/Typography";

import moment from "moment";
import PresidentsClubService from "../Security/PresidentsClubService/presidentsClubService";
import * as Sentry from "@sentry/browser";
import LayerLegacy from "../../LayerLegacy";
import MainContext from "../../Context/MainContext/MainContext";
import Table from "../../Component/Table";

export default class presidentsClubView extends LayerLegacy {
  constructor(props) {
    super(props);

    let years = [];
    // Get current year and last year...JK
    for (let i = 0; i < 2; i++) {
      years.push({
        label: moment().subtract(i, "years").get("year"),
        value: moment().subtract(i, "years").get("year"),
      });
    }
    this.state = {
      isLoaded: false,
      rows: [],
      years: years,
      selectedYear: years[0]?.value || moment().get("year"),
    };
  }

  componentDidMount() {
    this.retrievePresidentsClub(this.state.selectedYear);
  }

  static contextType = MainContext; // For legacy class components

  retrievePresidentsClub(year) {
    this.setState({ isLoaded: false });
    let filters = { year: year || "" };
    return PresidentsClubService.getPresidentsClub(filters)
      .then((res) => {
        let regEx = new RegExp("service|Service");
        let rows = [];
        res.forEach((e) => {
          if (!regEx.test(e.username)) {
            rows.push(e);
          }
        });
        this.setState({
          rows,
          isLoaded: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoaded: true });
      });
  }

  renderLoadingSpinner() {
    return (
      <Container className="mt-5">
        <div style={{ textAlign: "center", verticalAlign: "center" }}>
          <Spinner multicolor />
        </div>
      </Container>
    );
  }

  renderFilter() {
    return (
      <MUIFormControl size="small" sx={{ minWidth: 140 }}>
        <MUIInputLabel id="presidents-club-year-label">Year</MUIInputLabel>
        <MUISelect
          labelId="presidents-club-year-label"
          value={this.state.selectedYear}
          label="Year"
          disabled={!this.state.isLoaded}
          onChange={this.handleYearChange.bind(this)}
        >
          {this.state.years.map((yearOption) => (
            <MUIMenuItem key={yearOption.value} value={yearOption.value}>
              {yearOption.label}
            </MUIMenuItem>
          ))}
        </MUISelect>
      </MUIFormControl>
    );
  }

  handleYearChange(e) {
    const year = e.target.value;
    this.setState({ selectedYear: year });
    this.retrievePresidentsClub(year);
  }

  renderTableBody() {
    let lastPoints = null;
    let lastRank = 0;

    return this.state.rows.map((obj, index) => {
      const numericPoints = Number(obj.totalpoints);
      const normalizedPoints = Number.isNaN(numericPoints) ? 0 : numericPoints;
      const rank =
        lastPoints !== null && normalizedPoints === lastPoints
          ? lastRank
          : index + 1;

      lastPoints = normalizedPoints;
      lastRank = rank;

      return {
        id: `${obj.place}-${obj.username}-${index}`,
        rank,
        salesRepresentative: obj.username,
        points: normalizedPoints.toFixed(2),
      };
    });
  }

  renderMainCard() {
    return (
      <MUICard sx={{ maxWidth: 900, width: "100%", margin: "0 auto" }}>
        <MUICardContent>
          <MUIBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <MUITypography variant="h6">Presidents Club</MUITypography>
            {this.renderFilter()}
          </MUIBox>
          <Table
            rows={this.renderTableBody()}
            rowsPerPage={1000}
            search={false}
            export={false}
            columns={[
              { key: "rank", name: "Rank", type: "number", width: 100 },
              { key: "salesRepresentative", name: "Sales Representative" },
              { key: "points", name: "Points", width: 140 },
            ]}
          />
        </MUICardContent>
      </MUICard>
    );
  }

  renderContent() {
    if (this.state.isLoaded === false) {
      return this.renderLoadingSpinner();
    }
    return (
      <Container style={{ marginTop: "10px" }}>
        {this.renderMainCard()}
      </Container>
    );
  }

  render() {
    return this.renderContent();
  }
}
